export default function DropLi() {
  const Gender = [
    { id: 1, label: "Male" },
    { id: 2, label: "Female" },
    { id: 3, label: "Other" },
  ];
  const Role = [
    { id: 1, label: "Admin" },
    { id: 2, label: "Manager" },
    { id: 3, label: "Owner" },
    { id: 4, label: "Staff" },
    { id: 5, label: "Trainer" },
  ];
  const Languages = [
    { id: "en", label: "English" },
    { id: "ar", label: "Arabic" },
    { id: "bn", label: "Bangla" },
    { id: "hi", label: "Hindi" },
    { id: "zh", label: "Chinese" },
    { id: "fr", label: "French" },
  ];
  const PackageType = [
    { id: 1, label: "Main" },
    { id: 2, label: "Add On" },
  ];
  const Status = [
    { id: 1, label: "Pending" },
    { id: 2, label: "Complete" },
  ];
  const PayMethod = [
    { id: 1, label: "Cash" },
    { id: 2, label: "Cheque" },
    { id: 3, label: "Card Payment" },
    { id: 4, label: "Online Payment" },
  ];
  const Healths = [
    { id: 1, label: "Blood Pressure" },
    { id: 2, label: "Diabites" },
    { id: 3, label: "Back Pain" },
    { id: 4, label: "Cholestrol" },
    { id: 5, label: "Thyroid" },
    { id: 6, label: "Knee Pain" },
  ];

  const PaymentMethods = [
    { id: 1, label: "Cash" },
    { id: 2, label: "Cheque" },
    { id: 3, label: "Internet Banking" },
    { id: 4, label: "Debit Card" },
    { id: 5, label: "Credit Card" },
    { id: 6, label: "Google Pay" },
    { id: 7, label: "Other" },
  ];

  return {
    PaymentMethods,
    Gender,
    Status,
    Healths,
    Role,
    PayMethod,
    PackageType,
    Languages,
  };
}
